export default {
  lineColor: 'L',
  lineColorFull: 'Cor da linha',
  fillColor: 'O',
  fillColorFull: 'Cor do preenchimento',
  alpha: 'T',
  alphaFull: 'Transparência',
  lineWidth: 'A',
  lineWidthFull: 'Largura de linha',
  eraserWidth: 'B',
  eraserWidthFull: 'Largura do apagador',
  textColor: 'C',
  textColorFull: 'Cor do texto',
  fontSize: 'L',
  fontSizeFull: 'Tamanho da letra',
  fontStrokeSize: 'TLl',
  fontStrokeSizeFull: 'Tamanho da linha da letra',
  fontStyle: 'EL',
  fontStyleFull: 'Tipo de letra',
  fontName: 'NL',
  fontNameFull: 'Nome do tipo de letra',
  textStrokeColor: 'CL',
  textStrokeColorFull: 'Cor da letra',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  close: 'Fechar',
  clear: 'Limpar',
  width: 'Largura',
  height: 'Altura',
  keepRatio: 'Manter rácio Largura/Altura',
  fillPageWith: 'Preencher a página com a cor de fundo actual',
  pixelSize: 'P',
  pixelSizeFull: 'Tamanho de píxel',
  resizeScale: 'Escala',
  resizeResize: 'Redimensionar',
  backgroundColor: 'Cor de fundo da página',
  pixelizePixelSize: 'Tamanho de píxel ao Pixelizar',
  wrongPixelSizeValue:
    'Tamanho de píxel incorrecto. Podes colocar por exemplo \'20%\' que significa que o tamanho de píxel é 1/5 da área seleccionada, o \'4\' significa 4 px',
  tools: {
    crop: 'Recortar imagem pela área seleccionada',
    pixelize: 'Pixelizar a área seleccionada',
    rect: 'Desenhar rectângulo',
    ellipse: 'Desenhar elipse',
    line: 'Desenhar linha',
    rotate: 'Rodar imagem',
    save: 'Guardar imagem',
    load: 'Carregar imagem',
    text: 'Escrever texto',
    brush: 'Pincel',
    resize: 'Alterar tamanho ao redimensionar',
    open: 'Abrir imagem',
    select: 'Selecção da área',
    close: 'Fechar editor',
    eraser: 'Apagador',
    settings: 'Definições',
  },
  pasteOptions: {
    fit: 'Substituir tudo',
    extend_down: 'Acrescentar por baixo',
    extend_right: 'Acrescentar pela direita',
    extend: 'Acrescentar',
    over: 'Por cima',
    how_to_paste: 'Como colar?',
  },
};
